import UserBookmarkRecord from "models/view-models/user-bookmark-record";
import BookmarkCard from "../my-bookmarks/bookmark-card";
import React from "react";
import { useHistory, useLocation } from "react-router";
import { BookmarkUtils, ViewByGroup } from "utilities/bookmark-utils";

export const CSS_CLASS_NAME = "c-my-bookmarks-view-by-all";
export interface MyBookmarksListProps {
    bookmarks: UserBookmarkRecord[];
}
const MyBookmarksList = (props: MyBookmarksListProps) => {
    const { bookmarks } = props;
    const { push } = useHistory();
    const { search } = useLocation();

    const handleGoToBookmark = (id: number) => {
        const routeToDetailPage = BookmarkUtils.getDetailViewRoute(
            ViewByGroup.All,
            ViewByGroup.All,
            id
        );
        push(`${routeToDetailPage}${search}`);
    };

    return (
        <div className={`${CSS_CLASS_NAME}__list`}>
            {bookmarks &&
                bookmarks.map((bookmark: UserBookmarkRecord) => (
                    <BookmarkCard
                        bookmark={bookmark}
                        collections={[]}
                        inCollectionView={false}
                        key={bookmark.id}
                        onBookmarkDeleted={() => {}}
                        onBookmarkUpdated={() => {}}
                        onClick={() => handleGoToBookmark(bookmark.id!)}
                        publication={bookmark.createdOnPublication}
                    />
                ))}
        </div>
    );
};

export default MyBookmarksList;
